"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstNumber = getFirstNumber;
exports.jumpToSelector = jumpToSelector;

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _focusWithoutScrolling = _interopRequireDefault(require("../../utils/focusWithoutScrolling"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Parses the array argument and returns the first number value.
 * If no numbers are found, returns 0.
 *
 * @param {((number | undefined)[])} values
 * @returns {number}
 */
function getFirstNumber(values) {
  return values.find(_isNumber.default) || 0;
}

function scrollToElement(element, offset) {
  var targetOffset = element.getBoundingClientRect().top + window.pageYOffset;
  var scrollTargetY = targetOffset - offset; // does the current browser support smooth scrolling?

  var supportsNativeSmoothScroll = ('scrollBehavior' in document.documentElement.style); // in our testing supportsNativeSmoothScroll will always be true

  /* istanbul ignore else */

  if (supportsNativeSmoothScroll) {
    window.scroll({
      top: scrollTargetY,
      behavior: 'smooth'
    });
  } else {
    window.scroll(0, scrollTargetY);
  }
}

function jumpToSelector(selector, globalOffset, itemOffset) {
  var element = document.querySelector(selector);

  if (element) {
    var offset = getFirstNumber([itemOffset, globalOffset]);
    (0, _focusWithoutScrolling.default)(element);
    scrollToElement(element, offset);
  } else {
    // eslint-disable-next-line no-console
    console.warn("No element found for CSS selector ".concat(selector, ". JumpTo unable to scroll."));
  }
}